import _toConsumableArray from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { AppBar, Badge, Button, createStyles, Hidden, Menu, MenuItem, Popover, Toolbar, Typography, withStyles } from "@material-ui/core";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import PowerSettingsNew from "@material-ui/icons/PowerSettingsNew";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoginButton } from "../";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import samplesApi from "../../dal/samples";
import { getPopularTestCodesByInstitution } from "../../dal/tests";
import { colors, fonts } from "../../theme";
import { HeaderMenu } from "../HeaderMenu";
import { HeaderOverlay } from "../HeaderOverlay";
import HorizontalRibbon from "../HorizontalRibbon";
import CatalogHeader from "./CatalogHeader/CatalogHeader";
import OrderDropdown from "./OrderDropdown";
import VobDropdown from "./VobDropdown";
var styles = function styles(theme) {
  return createStyles({
    headerIcon: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 1em",
      textDecoration: "none",
      color: "white"
    },
    accountButton: _defineProperty({
      color: "white",
      fontFamily: fonts.fonts
    }, theme.breakpoints.down("md"), {
      height: 20
    }),
    userNameInfo: {
      padding: "5px 5px",
      textAlign: "left"
    },
    capitalizeText: _defineProperty({
      textTransform: "capitalize"
    }, theme.breakpoints.down("md"), {
      fontSize: "0.68rem"
    }),
    iconSize: _defineProperty({
      fontSize: "2.5em"
    }, theme.breakpoints.down("md"), {
      fontSize: "2em"
    }),
    notificationButtonRoot: {
      paddingLeft: 10,
      minWidth: 0,
      marginBottom: 4,
      textTransform: "none",
      fontWeight: "normal"
    },
    notificationButtonIcon: _defineProperty({
      fill: "white",
      marginTop: "4px",
      marginBottom: "4px",
      fontSize: "2.1em"
    }, theme.breakpoints.down("md"), {
      fontSize: "2.5em"
    }),
    badge: {
      marginLeft: -5,
      marginBottom: -5
    },
    notificationButtonLabel: _defineProperty({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontSize: "0.75rem"
    }, theme.breakpoints.down("md"), {
      fontSize: "0.6rem"
    }),
    headerLogo: _defineProperty({
      display: "inline-block",
      marginLeft: "-1.5em",
      height: "3.66rem"
    }, theme.breakpoints.down("md"), {
      height: "2.2rem"
    }),
    headerLogoContainer: {
      flexGrow: 1,
      display: "flex",
      marginTop: "auto",
      marginBottom: "auto"
    },
    loginButton: {
      marginLeft: -10,
      marginBottom: 25
    },
    hamburgerButton: {
      marginBottom: "6px",
      color: "white"
    },
    loginContainer: {
      padding: "5px 0px"
    },
    menuItem: {
      width: "15em"
    },
    toolbar: {
      marginTop: -4,
      marginBottom: -4
    },
    appBar: {
      backgroundColor: colors.deepSeaBlue,
      opacity: 0.87
    },
    version: {
      display: "flex",
      justifyContent: "flex-end",
      textAlign: "right",
      padding: "0 16px",
      fontSize: "10px"
    }
  });
};
var Header = function Header(_ref) {
  var hideLogin = _ref.hideLogin,
    _ref$showHamburger = _ref.showHamburger,
    showHamburger = _ref$showHamburger === void 0 ? false : _ref$showHamburger,
    institutionCode = _ref.institutionCode,
    classes = _ref.classes,
    isOnlyForLoading = _ref.isOnlyForLoading;
  var _useAuth = useAuth0(),
    isAuthenticated = _useAuth.isAuthenticated,
    loginWithRedirect = _useAuth.loginWithRedirect,
    logout = _useAuth.logout,
    selectedInstitution = _useAuth.selectedInstitution,
    physician = _useAuth.physician,
    emailVerified = _useAuth.emailVerified;
  var chooseLogo = function chooseLogo() {
    return window.innerWidth > 500 ? "/images/logo-reverse.svg" : "/images/logo-stack-reverse.svg";
  };
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    alertData = _useState2[0],
    setAlertData = _useState2[1];
  var _useState3 = useState({
      account: null,
      addButton: null,
      notification: null,
      menu: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    anchors = _useState4[0],
    setAnchors = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    popularTestCodes = _useState6[0],
    setPopularTestCodes = _useState6[1];
  var isCatalogPage = location.href.toLowerCase().includes(window.appConfig.catalogUrl);
  var toggleAnchorClick = function toggleAnchorClick(anchorKey, event) {
    setAnchors(Object.assign(Object.assign({}, anchors), _defineProperty({}, anchorKey, anchors[anchorKey] === null && event !== undefined ? event.currentTarget : null)));
  };
  var _useState7 = useState(chooseLogo()),
    _useState8 = _slicedToArray(_useState7, 2),
    logo = _useState8[0],
    setLogo = _useState8[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      return setLogo(chooseLogo());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  var _useAuth2 = useAuth0(),
    isAdmin = _useAuth2.isAdmin,
    isVA = _useAuth2.isVA;
  useEffect(function () {
    var getHeaderAlert = function getHeaderAlert() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return samplesApi.getHeaderAlert(selectedInstitution && selectedInstitution.institutionCode || "");
              case 2:
                result = _context.sent;
                setAlertData(result);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
    if (!isAuthenticated || !(selectedInstitution && selectedInstitution.institutionCode || alertData !== undefined)) {
      return;
    }
    if (!isOnlyForLoading) {
      try {
        getHeaderAlert();
      } catch (e) {}
    }
  }, []);
  useEffect(function () {
    var getPopular = function getPopular(intitutionCode) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var testCodes, vaPanels, vaTests;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getPopularTestCodesByInstitution(intitutionCode);
              case 2:
                testCodes = _context2.sent;
                if (!isVA) {
                  setPopularTestCodes(testCodes);
                } else {
                  setPopularTestCodes([]);
                  vaPanels = window.appConfig.vaPanels;
                  vaTests = []; // Add favorite test codes
                  if (testCodes) {
                    vaTests.push.apply(vaTests, _toConsumableArray(testCodes.map(function (tc) {
                      return {
                        tests: tc.tests
                      };
                    })));
                  }
                  // Add predefined test codes
                  vaTests.push({
                    tests: vaPanels.map(function (panel) {
                      return {
                        code: panel.testCodes[0],
                        testName: panel.testName,
                        id: 0,
                        displayInCatalog: false,
                        displayTestCode: panel.testName === "Single Gene" ? "1300" : ""
                      };
                    })
                  });
                  setPopularTestCodes(vaTests);
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };
    if (popularTestCodes === undefined && !isCatalogPage && selectedInstitution && selectedInstitution.institutionCode && !isOnlyForLoading) {
      getPopular(selectedInstitution.institutionCode);
    }
  }, [popularTestCodes, isCatalogPage, selectedInstitution]);
  var countAlerts = function countAlerts() {
    if (alertData) {
      var sum = 0;
      Object.values(alertData).map(function (v) {
        return sum += v;
      });
      return sum;
    }
    return 0;
  };
  var alertOpen = Boolean(anchors.notification);
  var alertId = alertOpen ? "simple-popover" : undefined;
  var numberOfAlerts = countAlerts();
  return isCatalogPage ? React.createElement(CatalogHeader, {
    showHamburger: showHamburger
  }) : React.createElement(React.Fragment, null, React.createElement(AppBar, {
    className: classes.appBar
  }, React.createElement(Toolbar, {
    variant: "dense",
    disableGutters: true,
    className: classes.toolbar
  }, React.createElement(HorizontalRibbon, null, isAuthenticated && (showHamburger ? React.createElement(React.Fragment, null, React.createElement(Button, {
    className: classes.hamburgerButton,
    id: "hamburger",
    onClick: function onClick(event) {
      return toggleAnchorClick("menu", event);
    }
  }, React.createElement(MenuIcon, null)), Boolean(anchors.menu) && React.createElement(HeaderMenu, {
    anchorEl: anchors.menu,
    open: true,
    onClose: function onClose() {
      return toggleAnchorClick("menu", undefined);
    }
  })) : React.createElement("div", null)), React.createElement("div", {
    className: classes.headerLogoContainer
  }, React.createElement(Link, {
    id: "Header-home-logo",
    to: "/",
    style: {
      width: "fit-content"
    }
  }, React.createElement("img", {
    src: logo,
    alt: "baylor-genetics-logo",
    className: classes.headerLogo
  }))), React.createElement("div", {
    className: classes.loginContainer
  }, !hideLogin && loginWithRedirect && !isAuthenticated && !!emailVerified && React.createElement(LoginButton, {
    id: "log-in",
    className: classes.loginButton,
    onClick: function onClick() {
      return loginWithRedirect({
        appState: {
          targetUrl: window.location
        }
      });
    }
  }, "LOGIN"), logout && !emailVerified && React.createElement(LoginButton, {
    id: "profile-sign-out",
    className: classes.loginButton,
    onClick: function onClick() {
      return logout({
        returnTo: window.appConfig.auth0Config.logoutRedirectUrl
      });
    }
  }, "LOGOUT"), logout && isAuthenticated && React.createElement(React.Fragment, null, popularTestCodes && institutionCode && React.createElement(React.Fragment, null, !window.appConfig.excludedInsuranceBillingHospitalCodes.includes(institutionCode) && React.createElement(VobDropdown, {
    tests: popularTestCodes
  }), React.createElement(OrderDropdown, {
    tests: popularTestCodes,
    institutionCode: institutionCode
  })), window.appConfig.enableNotifications && React.createElement(React.Fragment, null, React.createElement(Button, {
    id: "Header-notification-button",
    "aria-describedby": alertId,
    onClick: function onClick(event) {
      return toggleAnchorClick("notification", event);
    },
    classes: {
      root: classes.notificationButtonRoot,
      label: classes.notificationButtonLabel
    }
  }, React.createElement(Badge, {
    color: "error",
    invisible: numberOfAlerts === 0,
    variant: "dot",
    className: classes.badge,
    overlap: "rectangular"
  }, React.createElement(NotificationsNoneIcon, {
    className: classes.notificationButtonIcon
  })), React.createElement("span", null, "Notifications")), React.createElement(Popover, {
    id: alertId,
    open: alertOpen,
    anchorEl: anchors.notification,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    onClose: function onClose() {
      return toggleAnchorClick("notification", undefined);
    },
    disableRestoreFocus: true
  }, React.createElement(HeaderOverlay, {
    data: alertData
  }))), React.createElement(Button, {
    id: "profile",
    className: classes.accountButton,
    onClick: function onClick(event) {
      return toggleAnchorClick("account", event);
    }
  }, React.createElement(AccountCircleOutlinedIcon, {
    className: classes.iconSize
  }), React.createElement(Hidden, {
    xsDown: true
  }, React.createElement("div", {
    className: classes.userNameInfo
  }, React.createElement(Typography, {
    display: "block",
    variant: "caption",
    className: classes.capitalizeText
  }, "Welcome"), React.createElement(Typography, {
    display: "block",
    variant: "body2",
    className: classes.capitalizeText
  }, physician && "".concat(physician.firstName, " ").concat(physician.lastName).toLocaleLowerCase()))), React.createElement(ExpandMoreIcon, null)), Boolean(anchors.account) && React.createElement(Menu, {
    id: "profile-menu",
    anchorEl: anchors.account,
    keepMounted: true,
    open: Boolean(anchors.account),
    onClose: function onClose() {
      return toggleAnchorClick("account", undefined);
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, React.createElement(MenuItem, {
    id: "profile-link",
    className: classes.menuItem,
    onClick: function onClick() {
      return window.open("/profile", "_self");
    }
  }, React.createElement(AccountCircleOutlinedIcon, null), "\xA0\xA0 Profile"), window.appConfig.features.enableUserAdmin && isAdmin && React.createElement(MenuItem, {
    id: "profile-users",
    className: classes.menuItem,
    onClick: function onClick() {
      return window.open("/users", "_self");
    }
  }, React.createElement(PeopleOutlinedIcon, null), "\xA0\xA0 Manage Users"), React.createElement(MenuItem, {
    id: "profile-sign-out",
    className: classes.menuItem,
    onClick: function onClick() {
      return logout({
        returnTo: window.appConfig.auth0Config.logoutRedirectUrl
      });
    }
  }, React.createElement(PowerSettingsNew, null), "\xA0\xA0 Logout"), React.createElement("span", {
    className: classes.version
  }, process.env.REACT_APP_RELEASE_VERSION))))))));
};
export default withStyles(styles)(Header);